import React, { useEffect, memo } from 'react';
import { withTour } from "@reactour/tour";
import { injectIntl } from 'react-intl';
import TourContent from 'components/Tour/item';
import conferencePlaceholder from 'statics/images/placeholder/conferencePlaceholder.svg';
import tourDashboardPlaceholder from 'statics/images/placeholder/tourDashboardPlaceholder.svg';
import tourGroupPlaceholder from 'statics/images/placeholder/tourGroupPlaceholder.svg';
import tourCallPlaceholder from 'statics/images/placeholder/tourCallPlaceholder.svg';
import tourContactPlaceholder from 'statics/images/placeholder/tourContactPlaceholder.svg';
import tourUnicastPlaceholder from 'statics/images/placeholder/tourUnicastPlaceholder.svg';
import tourProfilePlaceholder from 'statics/images/placeholder/tourProfilePlaceholder.svg';
import tourAdminPlaceholder from 'statics/images/placeholder/tourAdminPlaceholder.svg';

const formatMessages = intl => () => ({
    dashboardTitle: intl.formatMessage({ id: 'tour.dashboard.title' }),
    dashboardDesc: intl.formatMessage({ id: 'tour.dashboard.desc' }),
    contactTitle: intl.formatMessage({ id: 'tour.contact.title' }),
    contactDesc: intl.formatMessage({ id: 'tour.contact.desc' }),
    profileTitle: intl.formatMessage({ id: 'tour.profile.title' }),
    profileDesc: intl.formatMessage({ id: 'tour.profile.desc' }),
    sipTitle: intl.formatMessage({ id: 'tour.sip.title' }),
    sipDesc: intl.formatMessage({ id: 'tour.sip.desc' }),
    adminTitle: intl.formatMessage({ id: 'tour.admin.title' }),
    adminDesc: intl.formatMessage({ id: 'tour.admin.desc' }),
    roomTitle: intl.formatMessage({ id: 'tour.room.title' }),
    roomDesc: intl.formatMessage({ id: 'tour.room.desc' }),
    groupsTitle: intl.formatMessage({ id: 'tour.groups.title' }),
    groupsDesc: intl.formatMessage({ id: 'tour.groups.desc' }),
    unicastTitle: intl.formatMessage({ id: 'tour.unicast.title' }),
    unicastDesc: intl.formatMessage({ id: 'tour.unicast.desc' }),
    neoConnectTitle: intl.formatMessage({ id: 'tour.neoconnect.title' }),
    neoConnectDesc: intl.formatMessage({ id: 'tour.neoconnect.desc' })
});

const TourInfos = (props) => {
    const { intl, isAdmin, hasPhone, hasNeoConnect, hasContacts, hasProfile, setSteps } = props;
    const i18n = formatMessages(intl)();

    useEffect(() => {
        const newSteps = [
            {
                selector: '#dashboard',
                content: (
                    <TourContent
                        title={i18n.dashboardTitle}
                        content={i18n.dashboardDesc}
                        src={tourDashboardPlaceholder}
                    />
                ),
                enabled: false
            },
            {
                selector: '#contacts',
                content: (
                    <TourContent
                        title={i18n.contactTitle}
                        content={i18n.contactDesc}
                        src={tourContactPlaceholder}
                    />
                ),
                enabled: hasContacts
            },
            {
                selector: '#profile',
                content: (
                    <TourContent
                        title={i18n.profileTitle}
                        content={i18n.profileDesc}
                        src={tourProfilePlaceholder}
                    />
                ),
                enabled: hasProfile
            },
            {
                selector: '#dashboard',
                content: (
                    <TourContent
                        title={i18n.sipTitle}
                        content={i18n.sipDesc}
                        src={tourCallPlaceholder}
                    />
                ),
                enabled: hasPhone
            },
            {
                selector: '#neoconnect',
                content: (
                    <TourContent
                        title={i18n.neoConnectTitle}
                        content={i18n.neoConnectDesc}
                    />
                ),
                enabled: hasNeoConnect
            },
            {
                selector: '#admin',
                content: (
                    <TourContent
                        title={i18n.adminTitle}
                        content={i18n.adminDesc}
                        src={tourAdminPlaceholder}
                    />
                ),
                enabled: isAdmin
            },
            {
                selector: '#rooms',
                content: (
                    <TourContent
                        title={i18n.roomTitle}
                        content={i18n.roomDesc}
                        src={conferencePlaceholder}
                    />
                )
            },
            {
                selector: '#groups',
                content: (
                    <TourContent
                        title={i18n.groupsTitle}
                        content={i18n.groupsDesc}
                        src={tourGroupPlaceholder}
                    />
                )
            },
            {
                selector: '#unicasts',
                content: (
                    <TourContent
                        title={i18n.unicastTitle}
                        content={i18n.unicastDesc}
                        src={tourUnicastPlaceholder}
                    />
                )
            }
        ]
        setSteps(newSteps.filter(s => s.enabled !== false));
    }, [setSteps, isAdmin, hasPhone]);

    return null;
}

export default injectIntl(withTour(memo(TourInfos, (prev, next) => (
    prev.isAdmin === next.isAdmin
    && prev.hasPhone === next.hasPhone
))));
